import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const Container = styled.div`
    padding: 15px 15px;
`;
export const Header = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    margin-top: -20px;
    ${media.mobileDevice`
    margin-top:0px;
    `}
`;
export const Icon = styled.img.attrs((props) => ({
    src: props.path,
}))`
    width: 22px;
    height: 23px;
    cursor : ${(props) => (props.cursor ? props.cursor : 'pointer')};
`;
export const HeaderTitle = styled.label`
    font-family: AvenirNextWorld Demi;
    color: #202124;
    font-size: 18px;
    margin-bottom: 12px;
    ${media.mobileDevice`
    margin-bottom:0px;
    `}
`;

export const Title = styled.div`
    font-family: AvenirNextWorld Demi;
    color: #202124;
    font-size: 14px;
    margin-bottom: 10px;

    &:after {
        content: '*';
        color: red;
        padding-left: 3px;
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${({ padding }) => (padding ? padding : '20px 24px')};
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 6px;
    // align-items:center;
`;
export const UploadImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${({ width }) => (width ? width : '226px')};
    height: 38px;
    border: 1px solid #1010eb;
    border-radius: 25px;
    font-size: 15px;
    font-family: AvenirNextWorld Demi;
    color: #1010eb;
    margin: 15px 0px 0px 0px;
    cursor: pointer;

    ${media.mobileDevice`
        width:${({ width }) => (width ? width : '246px')};
        padding: 6px 16px;
        font-size: 15px;
        line-height: 27px;
        font-family: AvenirNextWorld Demi;
        color: #1010eb;
    `}
    & label {
        width: 100%;
        text-align: center;
        cursor: pointer;
    }
`;
export const DeleteContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: auto;
    margin-top: 5px;
    height: 40px;
    ${media.mobileDevice`
      width: 100%;
    `}
`;
export const FileName = styled.p`
    font-size: 14px;
    font-family: AvenirNextWorld Regular;
    color: #151515;
    /* width: 60%; */
    cursor: pointer;
    ${media.mobileDevice`
       text-decoration: none;
    `}
`;
export const ActionButton = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 15px;
    justify-content: flex-end;

    ${media.mobileDevice`
        justify-content: center;
    `}
`;
export const DeleteIconView = styled.div`
    display: flex;
    height: 32px;
    width: 32px;
    box-shadow: 0px 0px 2px #00000029;
    border-radius: 6px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0 0 0 15px;
`;
export const WarningMsg = styled.div`
    display: ${({ display }) => display};
    word-break: break-all;
    font-size: 12px;
    color: red;
    font-family: AvenirNextWorld Regular;
    margin: 8px 0px;
`;
export const PdfMainContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 1px 4px #bdbdbd;
    margin: 16px;
    height: ${({ pdfContainerHeight }) => pdfContainerHeight};
    flex-direction: column;
`;
export const WarningMsgDiv = styled.div`
    display: flex;
    margin-top: 5px;
`;
